import {createSlice} from "@reduxjs/toolkit";

interface IInitState {
    query: string | undefined | null
    is_responded: boolean | undefined | 'all'
    star: number | undefined
    created_date: string | undefined
    page: number | undefined
}

const initialState: IInitState = {
    query: undefined,
    is_responded: undefined,
    star: undefined,
    created_date: undefined,
    page: 1
}

const reviewReducer = createSlice({
    name: 'review',
    reducers: {
        setReviewFilterData: (state, {payload}) => {
            if (payload.query || payload.query === '') {
                state.query = payload.query
            }
            if (payload.is_responded || payload.is_responded !== 'all') {
                state.is_responded = payload.is_responded
            }
            if (payload.star || payload.star !== 'all') {
                state.star = payload.star
            }
            if (payload.created_date || payload.created_date !== 'all') {
                state.created_date = payload.created_date
            }
            if (payload.is_responded === 'all') {
                state.is_responded = undefined
            }
            if (payload.star === 'all') {
                state.star = undefined
            }
            if (payload.created_date === 'all') {
                state.created_date = undefined
            }
            if (payload.query === '') {
                state.query = undefined
            }
            if (payload.page || payload.page === undefined) {
                state.page = payload.page
            }

        },
        clearQueryFilterData: (state) => {
            state.query = undefined
            state.page = undefined
        },
        clearQuery: (state) => {
            state.query = undefined
            state.is_responded = undefined
            state.star = undefined
            state.created_date = undefined
        }
    },
    initialState,

})

export const {setReviewFilterData, clearQueryFilterData, clearQuery} = reviewReducer.actions
export default reviewReducer.reducer
